
export default {
    name: 'BlogContactsNavMobile',
    props: {
        logged: {
            type: String,
            default: 'regular'
        }
    },
    components: {

    },
    mounted() {
    }
}